import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getDeliveryZoneById = id =>
  privateAxios({
    method: 'get',
    baseURL: adminAPI,
    url: `/deliveryzone/${id}`,
  });
